import { HYDRATION_ATTRIBUTE } from './shared.mjs';

const DEFAULT_HYDRATION_ID = Symbol('defaultId');
const DEFAULT_HYDRATION_PREFIX = 'hydration';
const EFFECT_ID = Symbol('react-hydrate');
class HydrationManager {
  constructor() {
    this.hydrated = false;
    this.effect = {
      id: EFFECT_ID,
      betweenEachPass: () => {
        this.ids.clear();
        this.hydration.clear();
      }
    };
    this.ids = new Map();
    this.hydration = new Map();

    if (typeof document !== 'undefined') {
      for (const element of document.querySelectorAll(`[${HYDRATION_ATTRIBUTE}]`)) {
        this.hydration.set(element.getAttribute(HYDRATION_ATTRIBUTE), element.innerHTML);
      }
    }
  }

  hydrationId(id) {
    const finalId = id || DEFAULT_HYDRATION_ID;
    const current = this.ids.get(finalId) || 0;
    this.ids.set(finalId, current + 1);
    return `${id || DEFAULT_HYDRATION_PREFIX}${current + 1}`;
  }

  getHydration(id) {
    return this.hydration.get(id);
  }

}

export { EFFECT_ID, HydrationManager };
